import React, { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Questionnaire } from "../Questionnarie/Questionnaire";
import { fetchPackagePreview } from "./preview-api";
import { LegacyStyledQuestion } from "./LegacyStyledQuestion";

// Package preview — paginated walkthrough of every section the package will
// render, using the legacy <Questionnaire/> shell so each page looks
// pixel-identical to /questionnaire/N. BACK/NEXT just flip the local
// pageIdx; nothing is saved.
export default function AdminPackagePreview() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [lang, setLang] = useState(params.get("lang") === "ar" ? "ar" : "en");

  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [pageIdx, setPageIdx] = useState(0);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    if (!id) return;
    fetchPackagePreview(id)
      .then((res) => setData(res))
      .catch(() => setError("Could not load package preview."));
  }, [id]);

  const sections = useMemo(() => data?.sections || [], [data]);

  if (error) return <div style={{ padding: 40, textAlign: "center" }}>{error}</div>;
  if (!data) return <div style={{ padding: 40, textAlign: "center" }}>Loading preview…</div>;
  if (!sections.length) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        {lang === "ar"
          ? "لا توجد أسئلة مهيأة لهذه الباقة بعد."
          : "No sections / questions are configured for this package yet."}
      </div>
    );
  }

  const current = sections[pageIdx] || sections[0];
  const bgTitle =
    lang === "ar" && current.title_arabic ? current.title_arabic : current.title_english;
  const pageNo =
    current?.sort_order && current.sort_order >= 1 && current.sort_order <= 7
      ? current.sort_order
      : pageIdx + 1;

  return (
    <Questionnaire
      bgTitle={bgTitle}
      pageNo={pageNo}
      Qlang={lang}
      setQLang={setLang}
      orderId={null}
      onBackClick={() => setPageIdx((p) => Math.max(0, p - 1))}
      onNextClick={() => setPageIdx((p) => Math.min(sections.length - 1, p + 1))}
      onSaveLaterClick={() => {}}
      storeAnswers={[]}
      formData={{}}
      setFormData={() => {}}
      questions={
        <>
          {(current.questions || []).map((q, idx) => (
            <LegacyStyledQuestion
              key={q.id}
              question={q}
              index={idx}
              value={answers[q.id]}
              onChange={(v) => setAnswers((p) => ({ ...p, [q.id]: v }))}
              lang={lang}
            />
          ))}
        </>
      }
    />
  );
}
